function init() {
	//Toggle menu
	$(".navbar-toggler-icon").removeClass("menu-active");
	$(".navbar-toggler-icon").addClass("show");
	
	$(".nav-toggle").unbind("click");
	$(".nav-toggle").bind("click",function(){
		navToggler();
	});
	
	//Menu select
	$("#main-nav ul li a").unbind("click");
	$("#main-nav ul li a").bind("click",function(e){
		var link = $(this);
		
		if(!link.parent().parent().parent().hasClass("submenu-container")){
			$(".submenu-container").removeClass("to-left");
			
			var hasSubmenu = link.closest("li").find(".submenu-container").length > 0;
			var menu = $("#main-nav ul:first");
			
			if(hasSubmenu){
				var submenu = link.closest("li").find(".submenu-container:first");
				var submenuLeft = parseInt(submenu.css("left").replace("px",""))+ parseInt(submenu.find("li").css("padding-left").replace("px",""));

				if(submenu.css("visibility") != "visible"){
					submenu.addClass("to-left");
					menu.css("left","-" + submenuLeft + "px");
					menu.addClass("menu-left");
				}
			}
		}
	});
	
	//Menu back
	$(".arrow-menu-back").unbind("click");
	$(".arrow-menu-back").bind("click", function(e){
		var menu = $("#main-nav ul:first");
		menu.removeClass("menu-left");
		goBack();
	});
	
	//Reset menu on resize
	$(window).resize(function() {
		resetMenu();
	});
	
	//Animate header
	setMenu();
	$(document).on("scroll", function() {
		setMenu();
	});
}

function goBack(){
	var menu = $("#main-nav ul:first");
	var submenus = $(".submenu-container");
	
	submenus.removeClass("to-left");
	menu.css("left","0");
}

function resetMenu(){
	var menu = $("#main-nav ul:first");
	var submenu = menu.find(".submenu-container:first");
	
	if(submenu.css("visibility") == "visible"){
		goBack();
	}
}

function setMenu(){
	if($(document).scrollTop() > 100) {
		$(".header").removeClass("scrolled-top").addClass("scrolled-down");
	} else {
		$(".header").removeClass("scrolled-down").addClass("scrolled-top");
	}
}

var scrollTop = 0;
function navToggler() {
	var nav = $("#main-nav");
	var navToggle = $(".nav-toggle:first");
	var header = $(".header");

	if (nav.height() == 0) {
		scrollTop = $(window).scrollTop();
		
		nav.addClass("menu-expanded");	
		navToggle.addClass("menu-active");
		
		$("body").css("position","fixed");
		$("body").css("width","100%");
	} else {
		nav.removeClass("menu-expanded");
		navToggle.removeClass("menu-active");
		
		$("body").css("position","static");
		$("body").css("width","auto");
		$(window).scrollTop(scrollTop);
	}
};
	
module.exports = {
	init : init
}